import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { IDENTIFICATIONCODETYPES_RESOURCE } from '../constants';

const TypesService = ComposedComponent =>
  reduxFetch([
    {
      resource: IDENTIFICATIONCODETYPES_RESOURCE,
      method: 'get',
      request: () => ({
        url: apiRoutes.identificationCodeTypes(),
      }),
    },
  ])(ComposedComponent);

export default TypesService;
